module.exports = __webpack_public_path__ + "static/media/new-canvas.f2a81754.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CanvasEditor/new-canvas.svg
// module id = 681
// module chunks = 0